import { delay, race, select, take } from 'redux-saga/effects';
import * as Vendor from './Vendor.reducer';

export function* waitForVendor(vendor, timeout = 3000) {
  const start = Date.now();
  while (__CLIENT__) {
    const hasExpired = yield select(Vendor.hasLoadingExpired, vendor, timeout);
    const isAvailable = yield select(Vendor.isAvailable, vendor);

    if (hasExpired || isAvailable) {
      return isAvailable;
    }

    yield race([take(Vendor.setAvailable().type), delay(timeout - (Date.now() - start))]);
  }

  return false;
}
